<template>
  <v-row class="my-5" align="center" justify="center">
    <v-col align="center">
      <h2 class="title-underline" translate>
        {{ $t(["404: Page not found"]) }}
      </h2>
      <p translate>
        {{ $t(["404_Text"]) }}
      </p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "PageNotFound",
};
</script>

<style lang="scss" scoped></style>
